<ng-container>
  <button mat-flat-button [matMenuTriggerFor]="menu">{{ label }}</button>
  <mat-menu #menu="matMenu" xPosition="before">
    <button
      *ngFor="let item of menuItems"
      (click)="item.action()"
      mat-menu-item
    >
      {{ item.label }}
    </button>
  </mat-menu>
</ng-container>
